<template>
<div class="inner-content emails-ws">
  <div class="emails-ws--messages">
    <div class="emails-wrapper">
      <main class="overflow-hidden">
        <header class="page header">
          <div class="content">
            <h1 class="mb-0">{{title}}</h1>
            <p class="lead text-muted">Rezervacije</p>
          </div>
        </header>

        <div class="content">
          <div class="row">
            <table id="dt-basic" class="table table-clean" style="width:100%">
              <thead>
                <tr>
                  <th>Plačnik</th>
                  <th>Št. gostov</th>
                  <th>Check-in</th>
                  <th>Check-out</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="booking in room.bookings">
                  <td>{{booking.payer.name.first}} {{booking.payer.name.last}}</td>
                  <td>{{booking.numGuests}}</td>
                  <td>{{booking.night.first}}</td>
                  <td>{{booking.night.last}}</td>
                  <td>{{booking.status}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </main>
    </div>
  </div>
  <div class="emails-ws--body">
    <router-view></router-view>
  </div>
</div>
</template>

<script>

import moment from 'moment';

export default {
  name: 'Room',
  data: () => ({
    title: '',
    room: {}
  }),
  beforeCreate() {
    const roomId = this.$route.params.roomId;
    //this.title = this.$parent.property.rooms.filter(r => r._id == roomId)[0].name

    fetch(process.env.VUE_APP_API + '/rooms?_id=' + roomId, {
      method: 'get',
      headers: {
        "Content-type": "application/json",
        "Accept": "application/json",
        "Accept-Charset": "utf-8",
        "CSRF-Token": this.$csrf
      }
    })
    .then(response => {
      return response.json();
    })
    .then(result => {
      console.log(result.error);
      this.room = result;
    })
  }
}
</script>
